<template lang="pug">
  user-viewer.user-viewer.show(
    online-payable-editable
    :uid="userID")
</template>

<script>
import UserViewer from '@/components/UserViewer.vue';

export default {
  props: {
    id: {
      type: String,
      require: true,
    },
  },
  computed: {
    userID() {
      return parseInt(this.id, 10);
    },
  },
  components: {
    'user-viewer': UserViewer,
  },
};
</script>
